
(function () {
  "use strict";

  var EVENT_NAME = "Launch Survey Submitted";
  var FALLBACK_PUBLIC_KEY = "VsNKDF";

  function initSurveys() {
    var surveys = document.querySelectorAll("[data-cc-survey]");

    surveys.forEach(function (root) {
      if (root.dataset.ccInitialized === "true") {
        return;
      }

      var questions = Array.from(
        root.querySelectorAll("[data-cc-question]")
      );

      var count = root.querySelector("[data-cc-count]");
      var bar = root.querySelector("[data-cc-bar]");
      var submit = root.querySelector("[data-cc-submit]");
      var note = root.querySelector("[data-cc-note]");
      var emailField = root.querySelector("[data-cc-email-field]");
      var emailInput = root.querySelector("[data-cc-email]");

      if (!count || !bar || !submit || !questions.length) {
        console.warn("Creatine Survey: Missing HTML elements.");
        return;
      }

      root.dataset.ccInitialized = "true";

      var params = new URLSearchParams(window.location.search);

      var siteId =
        root.getAttribute("data-site-id") ||
        FALLBACK_PUBLIC_KEY;

      var eventName =
        root.getAttribute("data-event-name") ||
        EVENT_NAME;

      var email = (
        params.get("email") ||
        root.getAttribute("data-customer-email") ||
        ""
      ).trim();

      if (!email && emailField) {
        emailField.classList.remove("cc-hidden");
      }

      // Read selected answers
      function getAnswer(question) {
        var type = question.getAttribute("data-type");

        if (type === "text") {
          var textarea = question.querySelector("[data-cc-text]");
          return textarea ? textarea.value.trim() : "";
        }

        var selected = Array.from(
          question.querySelectorAll(
            '[data-cc-option][aria-pressed="true"]'
          )
        ).map(function (button) {
          return button.getAttribute("data-value") || "";
        });

        if (type === "multi") {
          return selected;
        }

        return selected.length ? selected[0] : "";
      }

      function hasAnswer(question) {
        var answer = getAnswer(question);

        return Array.isArray(answer)
          ? answer.length > 0
          : answer !== "";
      }

      // Update progress bar
      function updateProgress() {
        var completed = questions.filter(hasAnswer).length;

        count.textContent =
          completed + " of " + questions.length + " done";

        bar.style.width =
          (completed / questions.length * 100) + "%";
      }

      // Set selected state
      function selectOption(question, selectedButton) {
        var type = question.getAttribute("data-type");
        var buttons = Array.from(
          question.querySelectorAll("[data-cc-option]")
        );

        var value = selectedButton.getAttribute("data-value");
        var currentlySelected =
          selectedButton.getAttribute("aria-pressed") === "true";

        if (type === "multi") {
          if (value === "Nothing") {
            buttons.forEach(function (button) {
              button.setAttribute("aria-pressed", "false");
            });

            selectedButton.setAttribute(
              "aria-pressed",
              currentlySelected ? "false" : "true"
            );
          } else {
            buttons.forEach(function (button) {
              if (button.getAttribute("data-value") === "Nothing") {
                button.setAttribute("aria-pressed", "false");
              }
            });

            selectedButton.setAttribute(
              "aria-pressed",
              currentlySelected ? "false" : "true"
            );
          }
        } else {
          buttons.forEach(function (button) {
            button.setAttribute(
              "aria-pressed",
              button === selectedButton ? "true" : "false"
            );
          });
        }

        question.classList.remove("cc-bad");
        updateProgress();
      }

      // Attach option events
      questions.forEach(function (question, index) {
        var buttons = question.querySelectorAll("[data-cc-option]");

        buttons.forEach(function (button) {
          button.addEventListener("click", function (event) {
            event.preventDefault();
            selectOption(question, button);
          });
        });

        var textarea = question.querySelector("[data-cc-text]");

        if (textarea) {
          textarea.addEventListener("input", function () {
            updateProgress();
          });
        }

        // Prefill q1=5 from Klaviyo email URL
        var prefill = params.get("q" + (index + 1));

        if (prefill) {
          buttons.forEach(function (button) {
            if (button.getAttribute("data-value") === prefill) {
              selectOption(question, button);
            }
          });
        }
      });

      updateProgress();

      // Validation
      function validateSurvey() {
        var firstInvalid = null;

        questions.forEach(function (question) {
          var required =
            question.getAttribute("data-required") === "true";

          var invalid = required && !hasAnswer(question);

          question.classList.toggle("cc-bad", invalid);

          if (invalid && !firstInvalid) {
            firstInvalid = question;
          }
        });

        if (!email && emailInput) {
          email = emailInput.value.trim();
        }

        var validEmail =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!validEmail && emailField) {
          emailField.classList.remove("cc-hidden");
          emailField.classList.add("cc-bad");

          if (!firstInvalid) {
            firstInvalid = emailField;
          }
        } else if (emailField) {
          emailField.classList.remove("cc-bad");
        }

        if (firstInvalid) {
          firstInvalid.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });

          return false;
        }

        return true;
      }

      // Build Klaviyo event properties
      function getProperties() {
        var properties = {
          survey: eventName,
          order: params.get("order") || "",
          page: window.location.pathname
        };

        questions.forEach(function (question, index) {
          var key =
            question.getAttribute("data-property") ||
            "question_" + (index + 1);

          var answer = getAnswer(question);

          properties[key] = Array.isArray(answer)
            ? answer.join(", ")
            : answer;
        });

        return properties;
      }

      // Send data to Klaviyo
      function sendToKlaviyo(properties) {
        if (!siteId) {
          return Promise.reject(
            new Error("Klaviyo Public Key missing.")
          );
        }

        var payload = {
          data: {
            type: "event",
            attributes: {
              properties: properties,
              metric: {
                data: {
                  type: "metric",
                  attributes: {
                    name: eventName
                  }
                }
              },
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email
                  }
                }
              }
            }
          }
        };

        return fetch(
          "https://a.klaviyo.com/client/events/?company_id=" +
          encodeURIComponent(siteId),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "revision": "2024-10-15"
            },
            body: JSON.stringify(payload)
          }
        ).then(function (response) {
          if (!response.ok) {
            throw new Error(
              "Klaviyo API error: " + response.status
            );
          }

          return response;
        });
      }

      // Submit survey
      submit.addEventListener("click", function (event) {
        event.preventDefault();

        if (!validateSurvey()) {
          return;
        }

        var properties = getProperties();
        var originalText = submit.textContent;

        submit.disabled = true;
        submit.textContent = "Sending...";

        if (note) {
          note.textContent = "Submitting your answers...";
        }

        sendToKlaviyo(properties)
          .then(function () {
            root.classList.add("cc-sent");

            if (count) {
              count.textContent =
                questions.length + " of " +
                questions.length + " done";
            }

            if (bar) {
              bar.style.width = "100%";
            }

            root.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          })
          .catch(function (error) {
            console.error("Creatine Survey Error:", error);

            submit.disabled = false;
            submit.textContent = originalText;

            if (note) {
              note.textContent =
                "Something went wrong. Please try again.";
            }
          });
      });
    });
  }

  // Works on normal Shopify storefront pages
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSurveys);
  } else {
    initSurveys();
  }

  // Works when Shopify Theme Editor reloads the section
  document.addEventListener("shopify:section:load", function () {
    initSurveys();
  });

})();
